export default __webpack_public_path__ + "static/media/bg3.5f3ab584.png";